// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allDocs from './Doc/_index.json' assert { type: 'json' }
import allBlogs from './Blog/_index.json' assert { type: 'json' }

export { allDocs, allBlogs }

export const allDocuments = [...allDocs, ...allBlogs]


